"use client";

import { NavLink } from "./NavLink";
import { usePathname } from "next/navigation";
import { startCase, upperFirst } from "lodash";

import type { BreadcrumbsTuple } from "@/shared/types/common/breadcrumb";

// Styles
import s from "./Breadcrumbs.module.scss";
import cn from "classnames";
import HomeIcon from "public/img/icons/sprite/home.svg";
import { SpriteIcon } from "@/components/UI/SpriteIcon";

interface BreadcrumbsProps {
  items?: BreadcrumbsTuple[];
  className?: string;
  isBlogPage?: boolean;
}

const generateBreadcrumbs = (pathName: string, isBlogPage?: boolean) => {
  const breadcrumbs: [string, string][] = [["Home", "/"]];

  pathName.split("/").forEach((path, idx) => {
    const href = pathName
      .split("/")
      .slice(0, idx + 1)
      .join("/");
    const name = upperFirst(startCase(path));
    if (!href) return;

    // Custom blog cases
    if (href.match(/^\/(authors|categories)$/gim) || (isBlogPage && idx === 1)) {
      breadcrumbs.push(["Blog", "/blog"]);
    }

    // Add breadcrumb to the list
    breadcrumbs.push([name, href]);
  });

  return breadcrumbs;
};

export const Breadcrumbs = ({ items, className, isBlogPage }: BreadcrumbsProps) => {
  const pathName = usePathname();

  const breadcrumbs = items || generateBreadcrumbs(pathName, isBlogPage);

  return (
    <ul className={cn(s.breadcrumbs, className)}>
      {breadcrumbs.map(([name, href], idx) => (
        <li key={href}>
          {idx + 1 !== breadcrumbs.length ? (
            <NavLink exact href={href}>
              {href === "/" ? <SpriteIcon icon={HomeIcon} /> : name}
            </NavLink>
          ) : (
            name
          )}
        </li>
      ))}
    </ul>
  );
};
